// #ux-redesign-start: PasswordRecovery rediseñada (Paso 5)
// Reemplaza el form Reactstrap/InputGroup por AuthLayout + AuthCard +
// primitivas del DS. Validación con react-hook-form v5 + yup.
//
// PORTABILIDAD: trasplantable a Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────

import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslate } from 'react-translate';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { actionRecoverPassword } from 'store/actions/usersActions';
import { Button, Input } from 'components/ds';
import AuthLayout from 'components/Auth/AuthLayout';
import AuthCard from 'components/Auth/AuthCard';

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PasswordRecovery = () => {
  const t = useTranslate('password-recovery');
  // #ux-redesign: comparte panel-title/panel-subtitle con el LoginPage
  const tLogin = useTranslate('login-page');
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const schema = yup.object().shape({
    email: yup.string().email().required(),
  });

  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: 'onBlur',
  });

  const onSubmit = async ({ email }) => {
    setSubmitting(true);
    await dispatch(
      actionRecoverPassword({
        email: email.toLowerCase().trim(),
        type: 'patient',
      })
    );
    setTimeout(() => setSubmitting(false), 2000);
  };

  const footerLinks = (
    <Link to="/auth/login-page">{t('back')}</Link>
  );

  return (
    <Fragment>
      <AuthLayout
        panelTitle={tLogin('panel-title')}
        panelSubtitle={tLogin('panel-subtitle')}
      >
        <AuthCard
          title={t('title')}
          description={t('description')}
          footerLinks={footerLinks}
        >
          <form className="ds-auth__form" onSubmit={handleSubmit(onSubmit)} noValidate>
            <Input
              name="email"
              type="email"
              label={t('email-placeholder')}
              placeholder={t('email-placeholder')}
              iconLeft={<MailIcon />}
              autoComplete="email"
              innerRef={register}
              error={errors.email?.message}
            />
            <div className="ds-auth__card-actions">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={submitting}
                name="forgot_buttton"
              >
                {t('send-btn')}
              </Button>
            </div>
          </form>
        </AuthCard>
      </AuthLayout>
    </Fragment>
  );
};

export default PasswordRecovery;
// #ux-redesign-end
